import {
    localSave,
    localRead,
    getMenuByRouter,
    getTagNavListFromLocalStorage,
    setTagNavListInLocalStorage,
} from '@/libs/util';
import routes from '@/router/main/index';
import config from '@/config';
import { getField, updateField } from '@/libs/vuexHelper';
import { getVisitorIpByStorage } from '@/api/sys/config';

export default {
    namespaced: true,
    state: {
        local: localRead('local'),
        // skin: localRead('skin'), // 没有维护深色模式  先固定light
        skin: 'light',
        collapsed: localRead('SIDEBAR_OPEN') === 'close',
        isOpen: localRead('SIDEBAR_OPEN') !== 'close',
        isFullScreen: false,
        isSaveGlobalSetting: true,
        tagNavList: [],
        excludeCompt: [],
        showAutomationGuideTips: false,
        hasSubMenu: false,
        showUserPoptip: false,
        visitorIpInfo: {},
        openedWindow: null,
        serverTimestamp: 0,
        recordTimestamp: 0,
        selectedContactView: {
            id: 'ALL_USER',
            value: [],
        }, // 当前选中的视图
    },
    getters: {
        getField,
        menuList: (state: any, getters: any, rootState: any) => getMenuByRouter(routes, rootState.user.access),
        isChinaIP(state: any) {
            return state.visitorIpInfo.ip_data?.country === 'cn';
        },
        // 是否柬埔寨IP
        // isCambodiaIP(state: any) {
        //     return state.visitorIpInfo.ip_data?.country === 'kh';
        // },
        isChinaDomain(state: any) {
            return window.location.hostname.indexOf('salesmartly.cn') > -1;
        },
        isCN(state: any, getters: any) {
            return getters.isChinaIP || getters.isChinaDomain;
        },
        // 菜鸟国际
        isCaiNiao() {
            const { siteConfig } = config;
            return siteConfig.brand && ['cninbox'].includes(siteConfig.key || '');
        },
    },
    mutations: {
        updateField,
        setLocal(state: any, lang: string) {
            const that = state;
            localSave('local', lang);
            that.local = lang;
        },
        setSkin(state: any, skin: string) {
            const that = state;
            localSave('skin', skin);
            that.skin = skin;
        },
        setCollapsedChange(state: any, value: boolean) {
            const that = state;
            that.collapsed = value;
        },
        setIsOpen(state: any, value: boolean) {
            const that = state;
            that.isOpen = value;
            that.collapsed = !value;
            localSave('SIDEBAR_OPEN', value ? 'open' : 'close');
        },
        setIsFullScreen(state: any) {
            const that = state;
            that.isFullScreen = !that.isFullScreen;
        },
        setIsSaveGlobalSetting(state: any, value: boolean) {
            const that = state;
            that.isSaveGlobalSetting = value;
        },
        setTagNavList(state: any, opt: { access: string[]; userId: string; list: any[] }) {
            let tagList: any = [];
            if (opt.list) {
                tagList = [...opt.list];
            } else {
                tagList = getTagNavListFromLocalStorage(opt.userId, routes, opt.access) || [];
            }
            state.tagNavList = tagList;
            setTagNavListInLocalStorage(opt.userId, [...tagList]);
        },
        setExcludeCompt(state: any, compt: string[]) {
            const that = state;
            that.excludeCompt = compt;
        },
        setShowUserPoptip(state: any, showUserPoptip: boolean) {
            state.showUserPoptip = showUserPoptip;
        },
        setVisitorIpInfo(state: any, visitorIpInfo: any) {
            state.visitorIpInfo = visitorIpInfo;
        },
        setOpenedWindow(state: any, window: Window | null) {
            state.openedWindow = window;
        },
        setServerTimestamp(state: any, timestamp: number) {
            state.recordTimestamp = Date.now();
            state.serverTimestamp = timestamp;
        },
    },
    actions: {
        collapsedChange({ commit }: any, value: boolean) {
            commit('setCollapsedChange', value);
        },
        getVisitorIpInfo({ commit }: any) {
            return getVisitorIpByStorage().then((res) => {
                commit('setVisitorIpInfo', res.data.data);
            }).catch(console.log);
        },
        handleChatWindow({ commit, state } : any) {
            if (state.openedWindow && !state.openedWindow.closed) {
                state.openedWindow.focus();
            } else {
                const width = Math.min(window.screen.width * 0.9, 820);
                const height = Math.min(window.screen.width * 0.9, 620);
                const screenLeft = window.screenLeft || window.screenX;
                const screenTop = window.screenTop || window.screenY;
                const left = screenLeft + (window.screen.availWidth - width) / 2;
                const top = screenTop + (window.screen.availHeight - height) / 2;
                const newWindow = window.open(
                    'https://chat.salesmartly.com/service/f11lv7v',
                    '',
                    `width=${width},height=${height},left=${left},top=${top}`,
                );
                commit('setOpenedWindow', newWindow);
                if (newWindow) {
                    newWindow.addEventListener('beforeunload', () => {
                        commit('setOpenedWindow', null);
                    });
                }
            }
        },
        // 获取当前服务端时间
        getCurrentTimestamp(state: any) {
            if (!state.serverTimestamp || !state.recordTimestamp) {
                return Date.now();
            }
            const now = Date.now();
            const diff = now - state.recordTimestamp;
            return state.serverTimestamp + diff;
        },
    },
};
